module.exports = "/_next/static/images/white-zpay@1x-e90c3daa742cff5f40093396ae13e159.png";